import {
  useHovercardHeading
} from "../__chunks/IZVL3EAG.js";
import "../__chunks/WW4JQU6W.js";
import "../__chunks/MEP5WKMB.js";
import "../__chunks/YAQX4NUA.js";
import "../__chunks/COQHFAEN.js";
import "../__chunks/LNHZLQEK.js";
import {
  createComponent,
  createElement,
  createHook
} from "../__chunks/NQJBHION.js";
import "../__chunks/J7Q2EO23.js";
import "../__chunks/CP3U4HPL.js";
import "../__chunks/PNRLI7OV.js";

// src/menu/menu-heading.ts
var useMenuHeading = createHook((props) => {
  props = useHovercardHeading(props);
  return props;
});
var MenuHeading = createComponent((props) => {
  const htmlProps = useMenuHeading(props);
  return createElement("h1", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  MenuHeading.displayName = "MenuHeading";
}
export {
  MenuHeading,
  useMenuHeading
};
